import React, { useState } from "react";
import { ModalBody, ModalFooter } from "react-bootstrap";
import Btn from "../ui/button/Btn";
import withModal from "./withModal";
import Input from "../ui/form/Input";

const UpdateNoteModalInner = ({
  onClose,
  onSubmit,
  message = "Please provide a reason or note for this update.",
  inputLabel = "Update Note",
  isSubmitting = false,
}) => {
  const [note, setNote] = useState("");
  const trimmed = note.trim();

  const handleSubmit = async () => {
    if (!trimmed || isSubmitting) return;
    await onSubmit(trimmed);
  };

  return (
    <>
      <ModalBody>
        <p className="mb-8 fs-sm text-secondary">{message}</p>
        <Input
          label={{ name: inputLabel }}
          input={{
            as: "textarea",
            rows: 4,
            value: note,
            onChange: (e) => setNote(e.target.value),
            placeholder: "Enter reason for update...",
            disabled: isSubmitting,
          }}
          required
        />
      </ModalBody>
      <ModalFooter className="gap-8">
        <Btn
          variant="cancel"
          title="Cancel"
          onClick={onClose}
          size="modal"
          disabled={isSubmitting}
        />
        <Btn
          type="button"
          variant="primary"
          title="Save & Proceed"
          size="modal"
          onClick={handleSubmit}
          disabled={isSubmitting || !trimmed}
        />
      </ModalFooter>
    </>
  );
};

const UpdateNoteModal = withModal(UpdateNoteModalInner);
export default UpdateNoteModal;
